import { router } from '../router';
import { Message } from 'element-ui';
import Vue from 'vue';
import i18n from '@/locales';

export function getBaseUrl(config, value) {
	return config.connections.filter((connection) => connection.value == value);
}

function makeNulls(arrayPrev) {
	let array = arrayPrev;
	for (let el in array) {
		if (array[el] === 'null') {
			array[el] = null;
		} else if (Array.isArray(array[el])) {
			for (let insEl in array[el]) {
				if (array[el][insEl] === 'null') {
					array[el][insEl] = null;
				}
				/* else if (array[el][insEl].test(reg)) {
					array[el][insEl] = parseInt(array[el][insEl]);
				} */
			}
		}
	}
	return array;
}

function parseError(error) {
	let message = '';
	// //console.log(error);
	const errorClass = error.class;
	const errorCode = error.code;

	//потом попросить у папы все коды
	if (errorClass === 'auth') {
		if (errorCode === 100) {
			message = i18n.t('general.errors.usernameNotFoundInDatabase');
		} else if (errorCode === 101 || errorCode === 2) {
			message = i18n.t('general.errors.usernameOrPasswordNotFound');
		} else if (errorCode === 102) {
			message = i18n.t('general.errors.accessDenied');
		} else if (errorCode === 103) {
			message = i18n.t('general.errors.invalidUsernameOrPassword');
		} else if (errorCode === 104) {
			message = i18n.t('general.errors.accountExpired');
		} else if (errorCode === 1 || errorCode === 3 || errorCode === 4) {
			message = i18n.t('general.errors.sessionExpired');
			clearSession();
		} else {
			message = error.msg;
		}
	} else {
		message = error.msg;
	}
	return message;
}

export function clearSession() {
	window.commit('setUser', null);
	window.commit('setBase', {
		url: null,
		label: null
	});

	Vue.localStorage.remove('wa-auth');
	Vue.localStorage.remove('wa-connection');

	// console.log('router', router);
	if (router.currentRoute.name !== 'loginLink')
		router.push({
			name: 'loginLink'
		});
}

function normalizeWhere(object) {
	/*Видоизменяю строку where для приема сервером (поставить окаймляюшие кавычки, все строки, true/false=> 1/0)*/
	for (let ob in object) {
		if (object[ob] === true) {
			object[ob] = '1';
		} else if (object[ob] === false) {
			object[ob] = '0';
		} else if (object[ob] === null) {
			object[ob] = 'null';
		} else if (typeof object[ob] === 'number') {
			object[ob] = `${object[ob]}`;
		} else if (typeof object[ob] === 'string') {
			object[ob] = `'${object[ob].trim().replace(/'/gi, "''")}'`;
			if (object[ob] === "''") {
				object[ob] = 'null';
			}
		}
	}
	return object;
}

function normalizeWhereRunScript(object) {
	for (let ob in object) {
		//console.log(object[ob]);
		object[ob] = `${object[ob]}`;
	}
	return object;
}

function setFieldNames(arrayOfObjects, headArray) {
	/*получаю два массива со значениеями и полями и собираю в один массив объектов с нужными полями */
	if (arrayOfObjects.length > 1) {
		let resObjectArray = [];
		arrayOfObjects.forEach((ob) => {
			let object = {};
			for (let i = 0; i < ob.length; i++) {
				//перевожу первую букву любого ключа в нижний регистр
				let key = Object.keys(headArray[i])[0];
				key = key.charAt(0).toLowerCase() + key.slice(1);
				object[key] = ob[i];
			}
			resObjectArray.push(object);
		});
		return resObjectArray;
	} else {
		//если не массив, а только один объект
		let object = {};
		for (let i = 0; i < arrayOfObjects[0].length; i++) {
			let key = Object.keys(headArray[i])[0];
			key = key.charAt(0).toLowerCase() + key.slice(1);
			object[key] = arrayOfObjects[0][i];
		}
		return object;
	}
}

export function checkResponse(response) {
	let result = {
		payload: null
	};
	// console.log('here: ', response.headers);
	if (response.headers.scgi_status !== '0') {
		//логическая ошибка от сервера
		result.message = parseError(response.data.error);
		result.code = 1;
		return result;
	} else if (response.data.error) {
		result.message = parseError(response.data.error);
		result.code = 1;
		return result;
	} else {
		//если логической ошибки нет
		//если передается таблица (поля body, head)
		if (response.data.body) {
			result.payload = response.data.body;
		} else result.payload = response.data; //если просто информация
		// console.log(result.payload);
		if (result.payload.modify != null && result.payload.modify === 0) {
			Message(i18n.t('general.errors.notModified'));
		}
		result.code = 0;
		if (Array.isArray(result.payload)) {
			if (result.payload.length > 0) {
				result.payload = makeNulls(result.payload);
				if (response.data.head) {
					result.payload = setFieldNames(result.payload, response.data.head);
				}
			} /* 
			else {
				result.code = 1;
				result.message = 'Empty data in response';
				result.payload = null;
			} */
		}
	}
	return result;
}

export function getQuery(body, where, login) {
	let object = {
		cmd: 'getQuery',
		body: body
	};
	if (where) {
		// для передачи массива id в select where in (...)
		if (typeof where === 'string' && (where.includes(',') || !isNaN(parseInt(where)))) {
			object.where = [where];
		} else object.where = normalizeWhere(where);
	}
	return postToServer(object, login);
}

export function execQuery(body, where, login) {
	let object = {
		cmd: 'execQuery',
		body: body
	};
	if (where) {
		object.where = normalizeWhere(where);
	}
	return postToServer(object, login);
}

export function runScript(body, where, login) {
	let object = {
		cmd: 'runScript',
		body: body
	};
	if (where) {
		object.where = normalizeWhereRunScript(where);
	}
	return postToServer(object, login);
}

export function luaScript(script, funcName, funcParam, login) {
	let object = {
		cmd: 'luaFunc',
		params: {
			script: script,
			funcname: funcName
			// funcparam: funcParam
		}
	};
	if (funcParam) object.params.funcparam = funcParam;
	return postToServer(object, login);
}

export function getVers(url) {
	let object = {
		cmd: 'getVers'
	};
	return new Promise((resolve, reject) => {
		Vue.axios
			.post(url, object)
			.then((response) => {
				resolve(response.data);
			})
			.catch((error) => {
				window.commit('setError', error);
				reject(error);
			});
	});
}

export function helperSignIn(object, url, connection, language) {
	// console.log(object);
	Vue.axios
		.post(url, object)
		.then((response) => {
			//console.log(response);
			const result = checkResponse(response);
			//console.log(result);
			if (result.code === 0) {
				const auth = result.payload;
				const login = object.login;
				const token = auth.token;
				const userid = auth.userid;
				const roleid = auth.roleid;
				const roletype = auth.roletype;
				const tokenId = auth.id.toString();
				const auth1 = {
					login,
					token,
					tokenId,
					userid,
					mpj: roleid,
					tpj: roletype
				};
				window.commit('setUser', {
					login,
					connection,
					token,
					tokenId,
					userid,
					roleid,
					roletype,
					language
				});
				Vue.localStorage.set('wa-auth', JSON.stringify(auth1));
				const connection1 = {
					connection,
					language
				};
				Vue.localStorage.set('wa-connection', JSON.stringify(connection1));
				router.push('/runtask/singletask');
			} else window.commit('setError', result.message);
		})
		.catch((error) => {
			window.commit('setError', error);
		});
}

export function helperSignOut(object, login) {
	postToServer(object, login).then(() => {
		clearSession();
	});
}

//пока использую для файлов, тип указывает, в каком формате возвращать (blob/text)
export function getFromServer(objectParams, type, login) {
	let object = {
		cmd: 'luaFunc',
		params: {
			...objectParams
		}
	};
	const obStr = JSON.stringify(object);
	// console.log(obStr, type);
	return Vue.axios.get(login.base.url + '?' + obStr, {
		headers: {
			Authorization: `{"token":["${login.user.token}","${login.user.tokenId}"]}`
		},
		responseType: type
	});
}

export function rawPostToServer(object, login) {
	return new Promise((resolve, reject) => {
		if (login.user !== null) {
			const headers = {
				headers: {
					Authorization: `{"token":["${login.user.token}","${login.user.tokenId}"]}`
				}
			};
			// console.log('send: ', object);
			Vue.axios
				.post(login.base.url, object, headers)
				.then((response) => {
					const result = checkResponse(response);
					// console.log('object: ', object);
					console.log('response: ', response);
					console.log('result ', result);
					//возвращает содержимое ответа наверх
					console.log(typeof result.payload);
					if (result.code === 0) resolve(response);
					else {
						window.commit('setError', result.message);
						reject(result.message);
					}
				})
				.catch((error) => {
					window.commit('setError', error);
					reject(error);
				});
		} else {
			reject();
		}
	})
}

//основная функция отправки на сервер - просто принимает файл, добавляет авторизацию,
//обрабатывает ответ на ошибки и передает его в промис наверх
export function postToServer(object, login) {
	return new Promise((resolve, reject) => {
		if (login.user !== null) {
			const headers = {
				headers: {
					Authorization: `{"token":["${login.user.token}","${login.user.tokenId}"]}`
				}
			};
			// console.log('send: ', object);
			Vue.axios
				.post(login.base.url, object, headers)
				.then((response) => {
					const result = checkResponse(response);
					// console.log('object: ', object);
					// console.log('response: ', response);
					// console.log('result ', result);
					//возвращает содержимое ответа наверх
					if (result.code === 0) resolve(result.payload);
					else {
						window.commit('setError', result.message);
						reject(result.message);
					}
				})
				.catch((error) => {
					window.commit('setError', error);
					reject(error);
				});
		} else {
			reject();
		}
	});
}
